import { FlowActionTypes, FlowContext } from 'contexts/FlowContext';
import type { FC } from 'react';
import { useContext } from 'react';
import EntityPicker from './EntityPicker';

interface FlowTriggerSettingsProps {
  locked?: boolean;
  // component?: Component;
}
const FlowTriggerSettings: FC<FlowTriggerSettingsProps> = ({ locked }) => {
  const ctx = useContext(FlowContext);
  const flow = ctx?.state.flow;
  if (flow && ctx?.state.selectedComponent && 'trigger' in ctx.state.selectedComponent) {
    return (
      <EntityPicker
        key="triggerSchema"
        property="triggerSchema"
        entityUUID={flow.config.triggerSchema}
        description="Requirements on the trigger of the flow"
        entity="structure"
        label="Select a Structure"
        // error={propertyErrors.length > 0}
        isEditable={locked !== true}
        showEntityLink
        onChange={(key, val) => {
          ctx.dispatch({
            type: FlowActionTypes.UPDATE_FLOW_SETTING,
            payload: {
              property: 'triggerSchema',
              value: val
            }
          });
        }}
      />
    );
  }

  return <>Not the Trigger</>;
};

export default FlowTriggerSettings;
